import TagManager from 'react-gtm-module';

import { EnvironmentVariable } from 'enums/curo/EnvironmentVariable';
import { envs } from 'envs';

const tagManagerArgs = {
  gtmId: envs[EnvironmentVariable.GoogleAnalyticsId],
};

export const initGTM = () => {
  if (envs[EnvironmentVariable.Environment] !== 'local') {
    TagManager.initialize(tagManagerArgs);
  }
};
